export function getDetailCountry(axiosPrivate, params) {
  return axiosPrivate.get(`/trade-data-management/detail-country?rep=${params.rep}`)
}

export function getDetailTradeFlow(axiosPrivate, params) {
  return axiosPrivate.get(
    `/trade-data-management/list-trade-flows?rep=${params.rep}&year=${params.year}&code=${params.code}&source_type=${params.source_type}`
  )
}

export function checkAvailabilityDataTradeFlow(axiosPrivate, params) {
  return axiosPrivate.post('/trade-data-management/check-availability-data-comtrade', params)
}

export function fetchDataTradeFlow(axiosPrivate, params) {
  return axiosPrivate.post('/trade-data-management/fetch-data-comtrade', {
    rep: params.rep,
    year: params.year,
    hs_vr: params.hs_vr,
  })
}

export function fetchMirrorData(axiosPrivate, params) {
  return axiosPrivate.post('/trade-data-management/fetch-mirror-data', {
    comtrade: params.comtrade,
    year: params.year,
  })
}

export function importDataManual(axiosPrivate, formData) {
  return axiosPrivate.post('/trade-data-management/import-data-manual', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
}
